import React from 'react';

export const issueTypeAvatarSizesMap = {
	xsmall: 16,
	small: 24,
	medium: 32,
	large: 40,
};

export type IssueTypeAvatarSizes = keyof typeof issueTypeAvatarSizesMap;

type Props = {
	avatarUrl: string;
	size: IssueTypeAvatarSizes;
	name?: string;
};

export const IssueTypeAvatar = ({ avatarUrl, size, name = '' }: Props): React.JSX.Element => {
	const sizeInPx = issueTypeAvatarSizesMap[size];

	return <img src={avatarUrl} alt={name} width={sizeInPx} height={sizeInPx} />;
};
